// Owner-инструменты закрытой беты: диагностика, backfill, debug-экспорт.
// Вынесено из api.ts (Фаза 1, разбор клиента по доменам).

import { request, requestBlob } from "./client";

export type ClosedBetaReadinessStatus = "READY" | "WARNING" | "BLOCKED";
export interface ClosedBetaReadinessCheck {
  code: string;
  label: string;
  status: ClosedBetaReadinessStatus;
  statusLabel: string;
  detail: string;
}
export interface ClosedBetaReadinessSection {
  code: string;
  title: string;
  status: ClosedBetaReadinessStatus;
  statusLabel: string;
  checks: ClosedBetaReadinessCheck[];
}
export interface ClosedBetaReadiness {
  status: ClosedBetaReadinessStatus;
  statusLabel: string;
  summary: string;
  score: number;
  blockers: number;
  warnings: number;
  sections: ClosedBetaReadinessSection[];
  testerGuidance: string[];
}
export interface BetaCycleDiagnostic {
  cycleId: string;
  cycleNumber: number;
  phase: string;
  actionsTotal: number;
  actionsWaitingForNarrative: number;
  npcVisitsOpen: number;
  initiativesTotal: number;
  cycleFactsTotal: number;
}
export interface BetaAdminDiagnostics {
  campaignId: string;
  checkedAt: string;
  toolsEnabled: boolean;
  summary: string;
  currentCycle?: BetaCycleDiagnostic;
  checks: ClosedBetaReadinessCheck[];
  safeActions: string[];
}
export interface BetaFactBackfill {
  campaignId: string;
  cycleId?: string;
  cycleNumber?: number;
  factsBefore: number;
  factsCreated: number;
  factsAfter: number;
  summary: string;
}
export interface BetaDebugExportLink {
  downloadUrl: string;
  fileName: string;
  expiresAt: string;
  publicEndpoint: boolean;
  warning: string;
}

export const betaApi = {
  betaDiagnostics: (campaignId: string) =>
    request<BetaAdminDiagnostics>(
      `/api/campaigns/${campaignId}/beta/diagnostics`,
    ),
  betaBackfillCurrentCycleFacts: (campaignId: string) =>
    request<BetaFactBackfill>(
      `/api/campaigns/${campaignId}/beta/facts/backfill-current-cycle`,
      { method: "POST" },
    ),
  betaDebugExportLink: (campaignId: string, cycleNumber?: number) =>
    request<BetaDebugExportLink>(
      `/api/campaigns/${campaignId}/beta/debug-export-link${cycleNumber ? `?cycleNumber=${cycleNumber}` : ""}`,
    ),
  betaDebugExport: (campaignId: string, cycleNumber?: number) =>
    requestBlob(
      `/api/campaigns/${campaignId}/beta/debug-export${cycleNumber ? `?cycleNumber=${cycleNumber}` : ""}`,
    ),
};
